export default __webpack_public_path__ + "static/media/3.12b9f29d.png";